import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

 
export const GetLocationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Location/GetLocationList?` + params, null);

export const CreateLocation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Location/CreateLocation`, data);

export const UpdateLocation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Location/UpdateLocation`, data);  

export const DeleteLocation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Location/DeleteLocation`, data);

export const GetLocationDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Location/GetLocationDetail?` + params, null);
